import { ordersHistoryListReducer } from './orders-history-list';
import { reducer as ReceiveDocumentReducer } from './receive-document-link';
import { reducer as ReturnsReducer } from './returns';

export const reducers = {
  ordersHistoryList: ordersHistoryListReducer,
  receiveDocument: ReceiveDocumentReducer,
  returns: ReturnsReducer,
};
